import React, { Fragment, FunctionComponent } from 'react';
import { Stepper, StepperStep } from '../../shared/Stepper';
import { Step1 } from './steps';
import { Link } from 'react-router-dom';
import { ArrowLongDown } from '../../../icons/components';

interface StepsArray {
	component: FunctionComponent<{ id: number }>;
}

const steps: StepsArray[] = [
	{
		component: Step1,
	},
];

export const AppointementStepper = () => {
	return (
		<Fragment>
				<span className="c-appointment-stepper__back-link">
					<Link to="/">
						<ArrowLongDown></ArrowLongDown> Terug
					</Link>
				</span>
			<Stepper defaultUrl="/" defaultPreviousText="Terug" previousButtonTexts={[]}>

				{steps &&
					steps.map((step, key) => (
						<StepperStep id={key} key={key}>
							<step.component id={key}/>
						</StepperStep>
					))}
			</Stepper>
		</Fragment>

	);
};
